import { ElementRef } from '@angular/core';
import { HOUSEHOLD_ACTIVE_TO_INACTIVE_WARNING, REGISTRATION_ACTIVE_TO_INACTIVE_WARNING, REGISTRATION_STATUS_OPTIONS, RegistrationStatus, RegistrationType, } from 'ClientManagementApp/ts/constants';
import { ToastMessageType } from 'NewAngular/features/components/toast-messages/toast-messages.enum';
import { RegistrationsService } from 'ClientManagementApp/ts/services/registrations.service';
import { PageToastMessagesService } from 'NewAngular/features/components/toast-messages/page-toast-messages-service';
import { DropdownHelperService } from 'NewAngular/services/dropdown-helper.service';
import { RegistrationToActiveModalComponent } from 'ClientManagementApp/ts/features/registration-to-active-modal/registration-to-active-modal.component';
import { ConfirmModalComponent } from 'NewAngular/features/components/modals/confirm-modal/confirm-modal.component';
import * as i0 from "@angular/core";
import * as i1 from "ClientManagementApp/ts/services/registrations.service";
import * as i2 from "NewAngular/features/components/toast-messages/page-toast-messages-service";
import * as i3 from "NewAngular/services/dropdown-helper.service";
import * as i4 from "@angular/common";
import * as i5 from "../../../../../../../ycharts/static/ts/features/components/toast-messages/page-toast-messages.component";
import * as i6 from "../../../../../../../ycharts/static/ts/features/components/modals/confirm-modal/confirm-modal.component";
import * as i7 from "../registration-to-active-modal/registration-to-active-modal.component";
const _c0 = ["confirmStatusChangeModal"];
const _c1 = ["toActiveModal"];
const _c2 = ["registrationStatusDropdown"];
function RegistrationStatusUpdateDropdownComponent_label_9_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "label", 11);
    i0.ɵɵlistener("click", function RegistrationStatusUpdateDropdownComponent_label_9_Template_label_click_0_listener() { const option_r3 = i0.ɵɵrestoreView(_r2).$implicit; const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.selectRegistrationStatus(option_r3)); });
    i0.ɵɵelementStart(1, "input", 12);
    i0.ɵɵlistener("click", function RegistrationStatusUpdateDropdownComponent_label_9_Template_input_click_1_listener($event) { i0.ɵɵrestoreView(_r2); $event.preventDefault(); return i0.ɵɵresetView($event.stopPropagation()); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "span", 13);
    i0.ɵɵelementStart(3, "span", 14)(4, "span", 6);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const option_r3 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("checked", ctx_r3.selectedStatus.value === option_r3.value);
    i0.ɵɵadvance(3);
    i0.ɵɵclassMap(option_r3.pillClass);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(option_r3.label);
} }
export class RegistrationStatusUpdateDropdownComponent {
    constructor(registrationsService, toastService, dropdownHelperService) {
        this.registrationsService = registrationsService;
        this.toastService = toastService;
        this.dropdownHelperService = dropdownHelperService;
        this.status = RegistrationStatus.ACTIVE;
        this.isDropdownOpen = false;
        this.statusOptions = REGISTRATION_STATUS_OPTIONS;
        this.selectedStatus = this.statusOptions[0];
    }
    ngOnInit() {
        this.setSelectedStatus(this.status);
    }
    ngAfterViewInit() {
        this.dropdownHelperService.setCloseHandler(this.registrationStatusDropdown.nativeElement, () => {
            this.isDropdownOpen = false;
        });
    }
    setSelectedStatus(status) {
        const matchingOption = this.statusOptions.find((option) => option.value.toLowerCase() === status.toLowerCase());
        if (matchingOption) {
            this.selectedStatus = matchingOption;
        }
    }
    updateStatus() {
        this.registrationsService
            .updateRegistrationStatus(parseInt(this.registrationId, 10), this.selectedStatus.value)
            .subscribe({
            next: () => {
                this.status = this.selectedStatus.value;
            },
            error: (err) => {
                this.toastService.addMessage(err.errorMessage, ToastMessageType.ERROR);
                this.setSelectedStatus(this.status);
            },
        });
    }
    selectRegistrationStatus(option) {
        // Update status before request so UI automatically updates.
        // On error this change is reverted.
        this.setSelectedStatus(option.value);
        this.toggleDropdown();
        if (this.status === RegistrationStatus.ACTIVE && this.selectedStatus.value !== RegistrationStatus.ACTIVE) {
            this.confirmStatusChangeModal.openModal();
        }
        else if (this.status !== RegistrationStatus.ACTIVE &&
            this.selectedStatus.value === RegistrationStatus.ACTIVE) {
            this.toActiveModal.openModal();
        }
        else {
            this.updateStatus();
        }
    }
    confirmStatusUpdateHandler(confirmed) {
        if (!confirmed) {
            this.setSelectedStatus(this.status);
            return;
        }
        this.updateStatus();
    }
    confirmToActiveHandler(confirmed) {
        if (!confirmed) {
            this.setSelectedStatus(this.status);
            return;
        }
        this.status = this.selectedStatus.value;
    }
    getStatusUpdateWarning() {
        if (this.registrationType === RegistrationType.HOUSEHOLD) {
            return HOUSEHOLD_ACTIVE_TO_INACTIVE_WARNING;
        }
        return REGISTRATION_ACTIVE_TO_INACTIVE_WARNING;
    }
    toggleDropdown() {
        this.isDropdownOpen = !this.isDropdownOpen;
    }
}
RegistrationStatusUpdateDropdownComponent.ɵfac = function RegistrationStatusUpdateDropdownComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || RegistrationStatusUpdateDropdownComponent)(i0.ɵɵdirectiveInject(i1.RegistrationsService), i0.ɵɵdirectiveInject(i2.PageToastMessagesService), i0.ɵɵdirectiveInject(i3.DropdownHelperService)); };
RegistrationStatusUpdateDropdownComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: RegistrationStatusUpdateDropdownComponent, selectors: [["ycn-registration-status-update-dropdown"]], viewQuery: function RegistrationStatusUpdateDropdownComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
        i0.ɵɵviewQuery(_c1, 5);
        i0.ɵɵviewQuery(_c2, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.confirmStatusChangeModal = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.toActiveModal = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.registrationStatusDropdown = _t.first);
    } }, inputs: { status: "status", registrationType: "registrationType", registrationId: "registrationId" }, standalone: false, decls: 14, vars: 14, consts: [["registrationStatusDropdown", ""], ["toActiveModal", ""], ["confirmStatusChangeModal", ""], [1, "dropdown"], [1, "dropdown-toggle", "btn", "btn-secondary", "width-full", 3, "click"], [1, "d-flex", "mr-auto"], [1, "pill"], [1, "dropdown-menu", "width-full"], ["class", "custom-control custom-checkbox custom-checkbox-style1 dropdown-item", "style", "cursor: pointer;", 3, "click", 4, "ngFor", "ngForOf"], [3, "confirmHandler", "registrationId"], [3, "confirmHandler", "confirmButtonText", "confirmHeader", "confirmText"], [1, "custom-control", "custom-checkbox", "custom-checkbox-style1", "dropdown-item", 2, "cursor", "pointer", 3, "click"], ["type", "checkbox", "readonly", "", 1, "custom-control-input", 3, "click", "checked"], [1, "custom-control-indicator"], [1, "custom-control-description"]], template: function RegistrationStatusUpdateDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 3, 0);
        i0.ɵɵelement(2, "ycn-page-toast-messages");
        i0.ɵɵelementStart(3, "div", 4);
        i0.ɵɵlistener("click", function RegistrationStatusUpdateDropdownComponent_Template_div_click_3_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.toggleDropdown()); });
        i0.ɵɵelementStart(4, "div", 5);
        i0.ɵɵtext(5, " STATUS:\u00A0");
        i0.ɵɵelementStart(6, "span", 6);
        i0.ɵɵtext(7);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(8, "div", 7);
        i0.ɵɵtemplate(9, RegistrationStatusUpdateDropdownComponent_label_9_Template, 6, 4, "label", 8);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(10, "ycn-registration-to-active-modal", 9, 1);
        i0.ɵɵlistener("confirmHandler", function RegistrationStatusUpdateDropdownComponent_Template_ycn_registration_to_active_modal_confirmHandler_10_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.confirmToActiveHandler($event)); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "ycn-confirm-modal", 10, 2);
        i0.ɵɵlistener("confirmHandler", function RegistrationStatusUpdateDropdownComponent_Template_ycn_confirm_modal_confirmHandler_12_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.confirmStatusUpdateHandler($event)); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵclassProp("show", ctx.isDropdownOpen);
        i0.ɵɵadvance(3);
        i0.ɵɵclassProp("active", ctx.isDropdownOpen);
        i0.ɵɵadvance(3);
        i0.ɵɵclassMap(ctx.selectedStatus.pillClass);
        i0.ɵɵadvance();
        i0.ɵɵtextInterpolate(ctx.selectedStatus.label);
        i0.ɵɵadvance();
        i0.ɵɵclassProp("show", ctx.isDropdownOpen);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngForOf", ctx.statusOptions);
        i0.ɵɵadvance();
        i0.ɵɵproperty("registrationId", ctx.registrationId);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("confirmButtonText", "Continue")("confirmHeader", "Registration Status Change Confirmation")("confirmText", ctx.getStatusUpdateWarning());
    } }, dependencies: [i4.NgForOf, i5.PageToastMessagesComponent, i6.ConfirmModalComponent, i7.RegistrationToActiveModalComponent], encapsulation: 2 });
